import React, { Fragment, useState, useEffect } from 'react'
import { TrendsChart } from 'Components/Chart'
import { chartColumns } from './Columns'
import { filteredClusterData, filteredTrendsData } from './Data'

const CloudCoreChart = ({ clusters, filters, trends }) => {
  const [filteredTrends, setFilteredTrends] = useState([])
  const [filteredChartColumns, setFilteredChartColumns] = useState([])

  useEffect(() => {
    const filteredClusters = filteredClusterData({ clusters, filters })
    const result = filteredTrendsData({ filteredClusters, filters, trends })
    setFilteredTrends(result)

    if(filters.nPlus) {
      const updatedChartColumns = chartColumns.map(column => ({ ...column }))
      const n1Text = ` (N+${filters.nPlus})`
      updatedChartColumns[1].label += n1Text
      updatedChartColumns[2].label += n1Text
      setFilteredChartColumns(updatedChartColumns)
    } else {
      setFilteredChartColumns(chartColumns)
    }
  }, [filters])
  
  return (
    <TrendsChart trends={filteredTrends} chartColumns={filteredChartColumns} filterWidth="300" />
  )
}

export default CloudCoreChart
